enum ErrorReferenceConstants {
  NETWORK_ERROR = 'Network Error',
  ECONNREFUSED = 'ECONNREFUSED',
  ERR_EMPTY_RESPONSE = 'ERR_EMPTY_RESPONSE',
  ERR_NAME_NOT_RESOLVED = 'ERR_NAME_NOT_RESOLVED',
  DNS_PROBE_FINISHED_NO_INTERNET = 'DNS_PROBE_FINISHED_NO_INTERNET',
}

enum ErrorMessageConstants {
  OOPS_SOMETHING_WENT_WRONG = 'errorMessages.somethingWentWrong',
  COULD_NOT_LOAD_DETAILS = 'errorMessages.couldNotLoad',
  COULD_NOT_CONNECT = 'errorMessages.couldNotConnect',
  DONT_KNOW_WHAT_HAPPENED = 'errorMessages.dontKnowWhatHappened',
  COMMON_MESSAGE = 'errorMessages.commonMessage',
}

export default { ErrorReferenceConstants, ErrorMessageConstants };
